import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import MigrationGitHubWorkflowsSection from './MigrationGitHubWorkflowsSection';
import MigrationCodeChangesTab from './MigrationCodeChangesTab';

/**
 * Azure Migration Statistics — cut-over, instance provisioning workflow metrics, and repo code changes.
 */
const AzureMigrationStatisticsTab = () => {
  const [subTab, setSubTab] = useState(0);

  return (
    <Box>
      <Tabs
        value={subTab}
        onChange={(_, v) => setSubTab(v)}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="Cut-over Migration" />
        <Tab label="Instance Provisioning" />
        <Tab label="Code Changes" />
      </Tabs>
      {subTab === 0 && <MigrationGitHubWorkflowsSection workflowProfile="cutover" key="cutover" />}
      {subTab === 1 && <MigrationGitHubWorkflowsSection workflowProfile="provisioning" key="provisioning" />}
      {subTab === 2 && <MigrationCodeChangesTab key="code-changes" />}
    </Box>
  );
};

export default AzureMigrationStatisticsTab;
